import axios from "../axios";

export const getProgramList = (params) => {
    return axios('get', '/api/program/getProgramList', params);
};